import React from 'react';
import {labels} from '../../../../util/uiconstants';

function EngagementUserHeader() {
	return (
		<section className="userlist-header">
			<section className="userlistheader motif-body2-default-regular">
				<section className="userlistitem userName">
					{labels.engmtUserTableUserNameHeader}
				</section>
				<section className="userlistitem emailAddress">
					{labels.engmtUserTableEmailAddressHeader}
				</section>
				<section className="userlistitem">
					{labels.engmtUserTableRoleHeader}
				</section>
				<section className="userlistitem gui">
					{labels.engmtUserTableGUIeHeader}
				</section>
				<section className="userlistitem status">
					{labels.engmtUserTableStatuseHeader}
				</section>
				<section className="userlistitem indstatus">
					{labels.engmtUserTableIndependenceStatuseHeader}
				</section>
				<section className="userlistitem adstatus">
					{labels.engmtUserTableADStatusHeader}
				</section>
				<section className="userlistitem permission">
					{labels.engmtUserTablePermissionsHeader}
				</section>
				<section className="editicon">&nbsp;</section>
			</section>
		</section>
	);
}

export default EngagementUserHeader;
